module.exports = __webpack_public_path__ + "img/landing_totem.279d4edd.gif";